import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import clsx from 'clsx'
import * as React from 'react'

import TextButton from '../../../atoms/Button/Text/Button'
import Paragraph from '../../../atoms/Paragraph'

interface Props {
  content?: any
  shouldMenuDisplay: boolean
}

const mainMenu = ({ content, shouldMenuDisplay }: Props) => {
  return (
    <div
      data-testid="megamenudesktop"
      className={clsx(
        'layoutSpacing hidden w-full border border-b-neutral-50 bg-white',
        shouldMenuDisplay && 'xl:flex',
      )}
    >
      <div className="layout w-full">
        <ul className="megaMenu">
          {content?.fields?.navigationSubSection?.fields?.menus.map((menuitem, index) => {
            const submenuList =
              menuitem?.fields?.menusDropdown &&
              menuitem?.fields?.menusDropdown.slice(0, menuitem?.fields?.menusDropdown.length - 1)
            const lastMenuItem =
              menuitem?.fields?.menusDropdown &&
              menuitem?.fields?.menusDropdown[menuitem?.fields?.menusDropdown.length - 1]
            const columnCount = Math.min(submenuList.length, submenuList.length > 4 ? 3 : 2)
            return (
              <li
                key={`"menu-"${index}`}
                className="hoverable float-left mr-32 border-b-2 border-white py-32 hover:border-purple-100 active:border-b-2 active:border-purple-100"
              >
                <TextButton
                  variant="dark"
                  name={menuitem?.fields?.groupName}
                  classes=" text-neutral-100 "
                  link={menuitem?.fields?.externelLink}
                />
                <div className="layoutSpacing mega-menu overflow-x-hidden bg-neutral-10 shadow-xl">
                  <div className="layout relative z-10 flex w-full flex-row flex-wrap justify-between after:absolute after:left-full after:top-0 after:-z-10 after:h-full after:w-50 after:bg-purple-10 after:content-['']">
                    <div className="flex w-75 py-48 pr-48">
                      <div className="flex w-100 gap-32">
                        <div className={clsx('gap-14', columnCount === 3 ? 'columns-3' : 'columns-2')}>
                          {submenuList.map((item, itemIndex) => (
                            <ul
                              key={itemIndex}
                              className="mb-32 break-inside-avoid-column w-100 border-b border-b-neutral-50 pb-8 last:mb-0 last:border-none"
                            >
                              <li className="justify-left mb-16">
                                <TextButton
                                  variant="dark"
                                  name={item?.fields?.menuName}
                                  link={item?.fields?.externelLink}
                                  classes="justify-left hover:underline"
                                />
                              </li>

                              <li className="justify-left mb-16">
                                <Paragraph
                                  content={documentToHtmlString(item?.fields?.menuDecription)}
                                  classes="flex items-start text-base textlink"
                                />
                              </li>
                            </ul>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="list flex w-25 flex-col items-start bg-purple-10 py-48 pl-48">
                      <ul className="flex w-100 flex-col">
                        <li className="justify-left mb-24">
                          <TextButton
                            variant="dark"
                            name={lastMenuItem?.fields?.menuName}
                            link={lastMenuItem?.fields?.externelLink}
                            fontColor="text-black"
                            classes="justify-left hover:underline font-normal"
                          />
                        </li>

                        <li className="justify-left mb-16">
                          <Paragraph
                            content={lastMenuItem?.fields?.menuDecription}
                            classes="flex items-start text-base mb-16 subMenulink"
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
export default mainMenu
